function getPath( path ) {
  const nPath = pathOrObj( path )
  if ( typeof nPath !== 'string' ) {
    return null
  }
  return `p/${nPath.split( '/' ).join( '/p/' )}`
}

function pathOrObj( pO ) {
  if ( typeof pO === 'string' ) {
    return pO
  }
  return pO && pO.path
}

export {
  // eslint-disable-next-line import/prefer-default-export
  getPath
}
